// 将毫秒值转为时间年/月/日
function getMyDate (str) {
  var oDate = new Date(str)
  var oYear = oDate.getFullYear()
  var oMonth = oDate.getMonth() + 1
  var oDay = oDate.getDate()
  var oHour = oDate.getHours()
  var oMin = oDate.getMinutes()
  var oSen = oDate.getSeconds()
  var oTime = oYear + '-' + addZero(oMonth) + '-' + addZero(oDay) + ' ' + addZero(oHour) + ':' + addZero(oMin) + ':' + addZero(oSen)
  return oTime
}
// 获取年月日
function getMyDayDate (str) {
  var oDate = new Date(str)
  var oYear = oDate.getFullYear()
  var oMonth = oDate.getMonth() + 1
  var oDay = oDate.getDate()
  var oTime = oYear + '-' + addZero(oMonth) + '-' + addZero(oDay)
  return oTime
}

// 补零操作
function addZero (num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}

export { getMyDate, getMyDayDate }
